module.exports = __webpack_public_path__ + "images/801b8c9403371b274e00261194e549a1.jpg";